import { Col, Row } from "react-bootstrap";
import section2Img from "../../../assets/images/phoneOnRock.png";
import { FaBan } from "react-icons/fa";
import { FaMoneyCheckAlt } from "react-icons/fa";
import { FaClock } from "react-icons/fa";
import { FaUsersCog } from "react-icons/fa";
import { FaUsers } from "react-icons/fa";
import { FaKey } from "react-icons/fa";

function section2() {
  return (
    <div>
      <Row>
        <Col sm={6} xs={12} style={{ margin: 0, padding: 0 }}>
          <img src={section2Img} alt="" className="HomeScreen-Section2-img" />
        </Col>
        <Col sm={6} xs={12} style={{ margin: 0, padding: 0 }}>
          <div className="HomeScreen-Section2-Box2">
            <div className="HomeScreen-section2-text1">
              Packed Full Of Features
            </div>
            <Row>
              <Col sm={6} xs={6}>
                <div className="HomeScreen-icon-container">
                  <FaBan size={40} />
                </div>
                <div className="HomeScreen-section2-text2">
                  Block Expired Subscriptions
                </div>
                <div className="HomeScreen-section2-text3">
                  Automatically manage access by blocking users with expired
                  subscriptions.
                </div>
              </Col>
              <Col sm={6} xs={6}>
                <div className="HomeScreen-icon-container">
                  <FaMoneyCheckAlt size={40} />
                </div>
                <div className="HomeScreen-section2-text2">
                  Transaction Management
                </div>
                <div className="HomeScreen-section2-text3">
                  Keep track of all financial transactions in one centralized
                  system.
                </div>
              </Col>
              <Col sm={6} xs={6}>
                <div className="HomeScreen-icon-container">
                  <FaClock size={40} />
                </div>
                <div className="HomeScreen-section2-text2">
                  Attendance Management
                </div>
                <div className="HomeScreen-section2-text3">
                  Track and manage attendance for employees, members, or
                  students with precision.
                </div>
              </Col>
              <Col sm={6} xs={6}>
                <div className="HomeScreen-icon-container">
                  <FaUsersCog size={40} />
                </div>
                <div className="HomeScreen-section2-text2">USM Management</div>
                <div className="HomeScreen-section2-text3">
                  Streamline your user service management with our comprehensive
                  USM tools.
                </div>
              </Col>
              <Col sm={6} xs={6}>
                <div className="HomeScreen-icon-container">
                  <FaUsers size={40} />
                </div>
                <div className="HomeScreen-section2-text2">
                  Membership Management
                </div>
                <div className="HomeScreen-section2-text3">
                  Efficiently manage all aspects of your membership program from
                  sign-up to renewal.
                </div>
              </Col>
              <Col sm={6} xs={6}>
                <div className="HomeScreen-icon-container">
                  <FaKey size={40} />
                </div>
                <div className="HomeScreen-section2-text2">
                  Token-Based Subscription
                </div>
                <div className="HomeScreen-section2-text3">
                  Implement flexible token-based subscription models for your
                  services.
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default section2;
